import { api } from "@/api";
import { FullMatchDto } from "./getFullMatches";

export const lockMatch = async (matchId: string): Promise<FullMatchDto> => {
  const res = await api.client.post(`/matches/${matchId}/sync-lock`);
  return res.data;
};

export const unlockMatch = async (matchId: string): Promise<void> => {
  await api.client.delete(`/matches/${matchId}/sync-lock`);
};
